import amySound from "../assets/sfx/amy.mp3";
import startSound from "../assets/sfx/start.wav";
import braylonSound from "../assets/sfx/braylon.mp3";
import isabelSound from "../assets/sfx/isabel.mp3";
import jamesSound from "../assets/sfx/james.mp3";
import kyraSound from "../assets/sfx/kyra.mp3";
import saevinSound from "../assets/sfx/saevin.mp3";
import isabel2Sound from "../assets/sfx/isabel2.mp3";
import ianSound from "../assets/sfx/ian.mp3";
import brynnSound from "../assets/sfx/brynn.mp3";
import valorantSound from "../assets/sfx/5kill.mp3";

import clickSound from "../assets/sfx/click.wav";
import errorSound from "../assets/sfx/errorr.mp3";
import uploadSound from "../assets/sfx/upload.mp3";

const startSounds = [
    amySound,startSound
]
const clickSounds = [
    [
        braylonSound,
        isabelSound,
        jamesSound,
        kyraSound,
        saevinSound
    ],[
        clickSound
    ]]
const uploadSounds = [
    valorantSound,uploadSound
]
const errorSounds = [
    [ianSound,brynnSound,isabel2Sound], [errorSound]
]

export function playClickSound(isFunny = false, soundsEnabled = false){
    if(!soundsEnabled) return;
    try {
        let index = isFunny ? 0 : 1;
        let sound = new Audio(clickSounds[index][Math.floor(Math.random() * (clickSounds[index].length))]);
        sound.play();
    } catch (error) {console.log(error)};
}
export function playStartSound(isFunny = false, soundsEnabled = false){
    if(!soundsEnabled) return;
    try{
        let index = isFunny ? 0 : 1;
        let sound = new Audio(startSounds[index]);
        sound.play();
    } catch (error) {console.log(error)}
}
export function playErrorSound(isFunny = false, soundsEnabled = false){
    if(!soundsEnabled) return;
    try{
        let index = isFunny ? 0 : 1;
        let sound = new Audio(errorSounds[index][Math.floor(Math.random() * (errorSounds[index].length))]);
        sound.play();
    } catch (error) {console.log(error)}
}
export function playUploadSound(isFunny = false, soundsEnabled = false){
    if(!soundsEnabled) return;
    try{
        let index = isFunny ? 0 : 1;
        let sound = new Audio(uploadSounds[index]);
        sound.play();
    } catch (error) {console.log(error)}
}
